<ng-container *transloco="let t">
	<div class="relative max-h-screen overflow-hidden overflow-y-auto overflow-x-hidden">
		<button
			title="Close modal"
			(click)="onClose()"
			class="absolute right-0 top-0 z-10 mr-1 mt-1 flex h-8 w-8 items-center justify-center text-blue-500 outline-none transition-colors duration-200 ease-in-out hover:text-orange-500"
		>
			<fa-icon [icon]="faClose"></fa-icon>
		</button>
		<div class="flex w-full flex-row flex-wrap">
			<div class="bg-gradient-offer w-full p-4 md:w-3/5 md:p-8">
				<div
					class="bg-size-140 absolute left-0 top-0 z-0 h-full w-full animate-wave bg-center bg-no-repeat"
					style="background-image: url('assets/images/stage/wave-blue.png')"
				></div>
				<header class="relative mb-4 border-b border-solid border-gray-550 pb-4">
					<h1 class="font-headline text-2xl font-bold text-white">
						<fa-icon class="mr-2 inline-block animate-wiggle-more text-white animate-infinite" [icon]="faBells"></fa-icon>
						{{ title }}
					</h1>
				</header>
				<main class="relative">
					<div class="wysiwyg wysiwyg--dialog" [innerHTML]="description"></div>
					<p class="mt-4 text-sm text-white">{{ claim }}</p>
					<div class="mt-8">
						<button
							(click)="onClose(sponsors[0])"
							class="mt-auto block transform appearance-none rounded-lg bg-blue-500 px-8 py-2 text-sm text-white shadow transition-all duration-700 ease-in-out hover:bg-orange-500"
						>
							{{ t('CONTEST.start') }}
						</button>
					</div>
				</main>
			</div>
			<div class="w-full md:w-2/5">
				<aside class="relative flex h-full flex-wrap bg-white p-4 md:p-8">
					<div class="relative">
						<div class="grid grid-cols-4 gap-8">
							@for (partner of sponsors; track partner.name) {
								<button
									class="h-auto w-full appearance-none object-contain object-center contrast-200 grayscale filter transition-none duration-200 ease-in-out hover:filter-none"
									(click)="onClose(partner)"
									[title]="t('UI.visit_sponsors_label') + partner.name"
								>
									<img class="mx-auto block h-auto w-full" [src]="partner.logo?.url" [alt]="partner.name" />
								</button>
							}
						</div>
					</div>
				</aside>
			</div>
		</div>
	</div>
</ng-container>
